import { NgModule } from '@angular/core';
import {
  PreloadAllModules,
  Route,
  RouterModule,
  Routes,
} from '@angular/router';
import { HomePage } from './pages/home/home.page';
import { ComponentsViewComponent } from './pages/components-view/components-view.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { CartComponent } from './pages/cart/cart.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { OrderSummaryComponent } from './pages/order-summary/order-summary.component';
import { ProductScannerComponent } from './pages/product-scanner/product-scanner.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { SignupComponent } from './pages/auth/signup/signup.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthedUserResolver } from './guards/authed-user.resolver';
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './pages/auth/change-password/change-password.component';
import { ModalCloseGuard } from './guards/modal-close.guard';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { InStoreProductsComponent } from './pages/in-store-products/in-store-products.component';
import { MyOrdersComponent } from './pages/my-orders/my-orders.component';
import { AboutComponent } from './pages/about/about.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { SubsidiesComponent } from './pages/subsidies/subsidies.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';
import { ImprintComponent } from './pages/imprint/imprint.component';
import { AccessControlComponent } from './pages/access-control/access-control.component';

export const rootRoutes: string[] = [
  'store',
  'profile',
  'cart',
  'scan',
  'in-store-products',
  'access-control',
];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'store',
    pathMatch: 'full',
  },
  {
    path: 'components',
    component: ComponentsViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'store',
    component: WelcomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'store/product/:id',
    component: ProductDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cart',
    component: CartComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'order-summary',
    component: OrderSummaryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    component: MyOrdersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'orders/:id',
    component: OrderDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'scan',
    component: ProductScannerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: [AuthedUserResolver],
  },
  {
    path: 'signup',
    component: SignupComponent,
    resolve: [AuthedUserResolver],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    resolve: [AuthedUserResolver],
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'in-store-products',
    component: InStoreProductsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'subsidies',
    component: SubsidiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
  },
  {
    path: 'imprint',
    component: ImprintComponent,
  },
  {
    path: 'access-control',
    component: AccessControlComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'store',
    pathMatch: 'full',
  },
].map((route: any) => {
  route.canDeactivate = [ModalCloseGuard];
  route.runGuardsAndResolvers = 'paramsOrQueryParamsChange';
  return route;
});

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
